module.exports = __webpack_public_path__ + "img/fantasy.bda726b0.png";